import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../auth/auth.service';
import { NotifyService } from '../../../common/notify/notify.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { ParticipantService } from '../../../services/participant.service';
import { Recipient } from '../../../interfaces/recipient';
import { Approval, ApprovalColumn, ApprovalColumnLabels, ApprovalStatus } from '../../../interfaces/approval';
import { Donor } from '../../../interfaces/donor';
import { CenterService } from '../../../services/center.service';
import { Center } from '../../../interfaces/center';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-request-privilege-donor',
  imports: [MatDialogModule, MatFormFieldModule, CommonModule, ReactiveFormsModule, FormsModule, MatOptionModule, MatSelectModule, MatInputModule, MatButtonModule],
  providers: [NotifyService],
  templateUrl: './request-privilege-donor.component.html',
  styleUrl: './request-privilege-donor.component.scss'
})
export class RequestPrivilegeDonorComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly participantService: ParticipantService,
    private readonly ref: MatDialogRef<RequestPrivilegeDonorComponent>,
    private readonly notify: NotifyService,
    private readonly cdr: ChangeDetectorRef,
    private centerService: CenterService,
    @Inject(MAT_DIALOG_DATA) readonly donor: Donor
  ) {}

  limitedToCenter?: Center[] = [];

  centers: Center[] = [];
  ngOnInit(): void {
    this.getAllCenters();
  }

  async apply() {
    // Update donor's limitedToCenter with the selected centers
    this.donor.limitedToCenter = this.limitedToCenter;

    this.participantService.updateDonor(this.donor).subscribe({
      next: (result) => {
        this.notify.withAutodismiss(`Updated donor ${this.donor.id} limited to centers.`);
        this.ref.close({ success: true, result });
      },
      error: (err) => {
        console.log(err);
        this.notify.withAutodismiss('Failed to update donor. Please try again.');
        this.ref.close({ success: false, error: err });
      }
    });
  }

  private getAllCenters(): void {
    this.centerService.getAllCenters().subscribe({
      next: (data) => {
        this.centers = data;
        // Map donor.limitedToCenter to the actual objects in centers array
        this.limitedToCenter = (this.donor?.limitedToCenter || []).map((selected) => this.centers.find((center) => center.id === selected.id)).filter(Boolean) as Center[];
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  cancel() {
    this.ref.close(false);
  }
}
